<form [formGroup]="tenantSelectionForm">
  <mat-form-field class="tenants-selection-list" appearance="fill">
    <mat-label>Selected Tenants</mat-label>
    <mat-chip-grid #tenantChipsCtrl aria-label="Tenant selection">
      @for (tenant of selectedTenants; track tenant) {
        <mat-chip-row
          [removable]="removable"
          (removed)="remove(tenant)">
          {{tenant.Text}}
          @if (removable) {
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          }
        </mat-chip-row>
      }
      <input
        placeholder="Filter by Tenants Text, Value, CrmId, CrmName (Case Insensitive)"
        #tenantInputCtrl
        [matAutocomplete]="auto"
        [matChipInputFor]="tenantChipsCtrl"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        formControlName="tenantInputCtrl">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (tenant of filteredTenants$ | async; track tenant) {
        <mat-option [value]="tenant.TenantId" [id]="tenant.Text">
          {{ tenant.Text }}
          {{ !tenant.Value ? '' : '(' + tenant.Value + ')' }}
          {{ !tenant.CrmId ? '' : 'CrmId: ' + tenant.CrmId }}
          {{ !tenant.CrmName ? '' : 'CrmName: ' + tenant.CrmName }}
        </mat-option>
      }
    </mat-autocomplete>
    <mat-error>At least 1 Tenant needs to be selected</mat-error>
  </mat-form-field>
</form>